interface LogoProps {
  size?: number
  variant?: 'full' | 'icon' | 'text'
  className?: string
}

export default function Logo({ size = 40, variant = 'full', className = '' }: LogoProps) {
  if (variant === 'icon') {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
      >
        {/* Background Circle with Gradient */}
        <defs>
          <linearGradient id="qorder-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#2563eb', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#7c3aed', stopOpacity: 1 }} />
          </linearGradient>
          <linearGradient id="plate-gradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#e0e7ff', stopOpacity: 1 }} />
          </linearGradient>
        </defs>

        {/* Main Circle Background */}
        <circle cx="50" cy="50" r="48" fill="url(#qorder-gradient)" />

        {/* Plate Circle */}
        <circle cx="50" cy="52" r="32" fill="url(#plate-gradient)" opacity="0.95" />
        <circle cx="50" cy="52" r="28" fill="none" stroke="#2563eb" strokeWidth="1.5" opacity="0.3" />

        {/* Fork on Left */}
        <g transform="translate(26, 35)">
          <rect x="0" y="0" width="2" height="28" rx="1" fill="#2563eb" />
          <rect x="0" y="0" width="2" height="8" rx="1" fill="#2563eb" />
          <rect x="-3" y="0" width="2" height="8" rx="1" fill="#2563eb" />
          <rect x="3" y="0" width="2" height="8" rx="1" fill="#2563eb" />
        </g>

        {/* Knife on Right */}
        <g transform="translate(70, 35)">
          <rect x="0" y="0" width="2.5" height="28" rx="1" fill="#2563eb" />
          <path d="M 0,0 L 2.5,0 L 4,8 L -1.5,8 Z" fill="#2563eb" />
        </g>

        {/* Letter Q in the center */}
        <text
          x="50"
          y="58"
          fontSize="28"
          fontWeight="bold"
          fill="#2563eb"
          textAnchor="middle"
          fontFamily="system-ui, -apple-system, sans-serif"
        >
          Q
        </text>
      </svg>
    )
  }

  if (variant === 'text') {
    return (
      <div className={`flex items-center ${className}`}>
        <span
          className="font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          style={{ fontSize: size }}
        >
          Qorder
        </span>
      </div>
    )
  }

  // Full logo with icon + text
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background Circle with Gradient */}
        <defs>
          <linearGradient id="qorder-gradient-full" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#2563eb', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#7c3aed', stopOpacity: 1 }} />
          </linearGradient>
          <linearGradient id="plate-gradient-full" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#e0e7ff', stopOpacity: 1 }} />
          </linearGradient>
        </defs>

        {/* Main Circle Background */}
        <circle cx="50" cy="50" r="48" fill="url(#qorder-gradient-full)" />

        {/* Plate Circle */}
        <circle cx="50" cy="52" r="32" fill="url(#plate-gradient-full)" opacity="0.95" />
        <circle cx="50" cy="52" r="28" fill="none" stroke="#2563eb" strokeWidth="1.5" opacity="0.3" />

        {/* Fork on Left */}
        <g transform="translate(26, 35)">
          <rect x="0" y="0" width="2" height="28" rx="1" fill="#2563eb" />
          <rect x="0" y="0" width="2" height="8" rx="1" fill="#2563eb" />
          <rect x="-3" y="0" width="2" height="8" rx="1" fill="#2563eb" />
          <rect x="3" y="0" width="2" height="8" rx="1" fill="#2563eb" />
        </g>

        {/* Knife on Right */}
        <g transform="translate(70, 35)">
          <rect x="0" y="0" width="2.5" height="28" rx="1" fill="#2563eb" />
          <path d="M 0,0 L 2.5,0 L 4,8 L -1.5,8 Z" fill="#2563eb" />
        </g>

        {/* Letter Q in the center */}
        <text
          x="50"
          y="58"
          fontSize="28"
          fontWeight="bold"
          fill="#2563eb"
          textAnchor="middle"
          fontFamily="system-ui, -apple-system, sans-serif"
        >
          Q
        </text>
      </svg>

      <span
        className="font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
        style={{ fontSize: size * 0.6 }}
      >
        order
      </span>
    </div>
  )
}
